import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "recaptcha" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_AppBar = _resolveComponent("AppBar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SideBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBar),
      _createVNode(_component_router_view)
    ]),
    _hoisted_3
  ]))
}